/* ============
 * MomentJS
 * ============
 *
 * Parse, validate, manipulate, and display dates and times in JavaScript.
 *
 * https://momentjs.com/
 */

import moment from 'moment';

moment.locale('es');

export default moment;
